<template>
  <div class="portals">
    <!-- <div class="box is-shadowless"> -->
      <portal-table />
    <!-- </div> -->
  </div>
</template>
<script>
import PortalTable from "./partials/table";
export default {
	components: {
		PortalTable,
	}
};
</script>


// WEBPACK FOOTER //
// src/components/pages/Portals/index.vue